const releasesHR = {
    "view": {
        "table": {
            "title": "Vaš popis izdanja",
            "column": {
                "name": "Ime",
                "artist": "Umjetnik",
                "catalogue_number": "Kat. br.",
                "release_date": "Datum izdanja",
                "status": "Status",
                "store_urls": "URL-ovi trgovine",
                "qc": "QC",
                "pre_scan": "Pre-Scan",
                "alert": "Upozorenje",
                "flagged": "Označeno",
                "action": "Akcija"
            },
            "label": {
                "status_ready": "Spremno",
                "status_approval": "Podnošenje u redu čekanja",
                "status_takedown_request": "Zahtjev za uklanjanje",
                "status_taken_down": "Uklonjeno",
                "status_distributed": "Distribuirano",
                "status_locked": "U tijeku - Zaključano",
                "status_delivering": "Dostava",
                "status_unlocked": "Molimo uredite",
                "status_offline": "Izvan mreže",
                "status_re_delivery-delivery": "Ponovna dostava",
                "status_re_delivery-editing": "Uređivanje ponovne dostave",
                "status_unknown": "Nepoznati status"
            },
            "button": {
                "export_csv": "Izvezi CSV"
            },
            "placeholder": {
                "search": "Pretraži..."
            },
            "dropdown": {
                "item": {
                    "action": "Akcija",
                    "distribute": "Distribuiraj",
                    "viewRelease": "Pregledaj izdanje",
                    "editReleaseMetadata": "Uredi metapodatke izdanja",
                    "editTracks": "Uredi pjesme",
                    "takedown": "Ukloni",
                    "submitEditing": "Podnesi uređivanje",
                    "deliveredList": "Popis dostavljenih",
                    "copyEanUpc": "Kopiraj EAN/UPC"
                },
                "message": {
                    "submitInformationTooltip": "Još niste pružili sve svoje podatke, stoga ne možete distribuirati izdanja. Da biste to učinili, molimo podnesite svoje podatke.",
                    "submitMetadataTooltip": "Molimo podnesite metapodatke za sve pjesme kako biste distribuirali izdanje.",
                    "submitEditingMetadataTooltip": "Molimo podnesite metapodatke za sve pjesme kako biste podnijeli uređivanja.",
                    "submitEditingTokenRequiredTooltip": "Za slanje uređivanja za ponovnu dostavu potreban je najmanje 1 token. <2>Naručite tokene</2>.",
                    "blacklistedArtistTooltip": "Ovo izdanje ne može biti distribuirano jer sadrži jednu ili više pjesama od blacklisted umjetnika. Molimo kontaktirajte naš tim za podršku za više informacija.",
                    "distributionDisabledPreScanInProgress": "Molimo pričekajte da se pre-scan završi prije distribuiranja izdanja.",
                    "distributionDisabledPreScanNotDone": "Molimo izvršite pre-scan prije distribuiranja izdanja.",
                    "distributionDisabledPreScanDeclarationNotSubmitted": "Molimo podnesite pre-scan deklaraciju prije distribuiranja izdanja.",
                },
                "modal": {
                    "editMetadata": {
                        "header": "Jeste li sigurni da želite urediti metapodatke?",
                        "description": {
                            "point1": "<strong>Ovo će promijeniti vaše metapodatke i može utjecati na izdanje.</strong>",
                            "point2": "Nastavite samo ako ste potpuno sigurni.",
                            "point3": "<strong>MOLIMO NE</strong> uređujte metapodatke samo za testiranje i istraživanje."
                        },
                        "button": {
                            "cancel": "Otkaži",
                            "confirm": "Razumijem"
                        }
                    },
                    "distribute": {
                        "header": "Jeste li sigurni da su svi uneseni podaci valjani i potpuno predstavljaju ovo izdanje?",
                        "description": {
                            "point1": "Nakon ove akcije, vaše izdanje će biti provjereno i ako su podaci točni, bit će distribuirano na službene i ekskluzivne datume distribucije.",
                            "point2": "Potvrdom i prihvaćanjem ovog obrasca, u potpunosti prihvaćate i pridržavate se <1>Uvjeta distribucije</1>, <3>Uvjeta korištenja</3> i <5>Pravila o privatnosti</5>.",
                            "point3": "Potvrdom i prihvaćanjem ovog obrasca, nesporno potvrđujete da vam sadržaj izdanja s pripadajućim sredstvima, audio datotekama i metapodacima, ili isključivo pripada ili je potpuno licenciran vašoj etiketi.",
                            "point4": "Ovim u potpunosti prihvaćate da ćete biti isključivo odgovorni za bilo kakve obmanjujuće informacije, nelicenciranu upotrebu, nezakonite aktivnosti ili bilo kakve sporove.",
                            "flaggedTracksTerms": {
                                "header": "Uvjeti za označene pjesme",
                                "point1": "Napomena: <strong>'{{releaseName}}'</strong> sadrži jednu ili više označenih pjesama, naknada od <strong>15 €</strong> po označenoj pjesmi primjenjuje se kako bi se izdanje dostavilo na <strong>Spotify</strong>. Kako ste odlučili ne platiti ovu naknadu u ovom trenutku, izdanje neće biti dostavljeno na Spotify. Potvrdom i prihvaćanjem ovog obrasca, priznajete i prihvaćate ove uvjete.",
                                "point2": "U budućnosti, ako odlučite da se izdanje dostavi na <strong>Spotify</strong>, možete otići u odjeljak Označeno u tablici Izdanja i slijediti upute za plaćanje."
                            },
                            "artificialStreamingDeclaration": {
                                "header": "Izjava o umjetnom streamingu",
                                "point1": "<strong>1.</strong> Potpuno razumijem i slažem se da se neću upuštati u bilo kakav oblik umjetnog streaminga, uključujući korištenje botova, streaming farmi ili bilo koje metode koja manipulira DSP metrikama.",
                                "point2": "<strong>2.</strong> Neću plaćati niti nuditi plaćanje za plasman na playlistu, niti ću raditi s bilo kojom trećom stranom koja obećava zajamčeni plasman — razumijem da se to smatra prijevarom i prevarom.",
                                "point3": "<strong>3.</strong> Priznajem da bilo kakve takve radnje mogu rezultirati trenutnim raskidom, gubitkom tantijema, pravnim zahtjevima, ugovornim kaznama i naknadama te prijavom DSP-ovima i vlastima.",
                                "point4": "<strong>4.</strong> Također jamčim da ću informirati i educirati sve umjetnike ili klijente s kojima radim o ovim pravilima i osigurati da ih se pridržavaju.",
                                "point5": "<strong>5.</strong> Razumijem da ako se upustim u umjetni streaming, moji KYC podaci, uključujući moje puno ime, adresu, osobnu iskaznicu i druge osobne podatke, mogu biti podijeljeni s pravnim odjelima DSP-a, kao što su oni Spotifyja, Apple Musica i drugih.",
                                "point6": "<strong>6.</strong> Prihvaćam punu pravnu odgovornost za bilo kakve povrede.",
                                "acknowledgment": "Ovim potvrđujem i slažem se pridržavati se gore navedenih uvjeta umjetnog streaminga i prihvaćam punu pravnu odgovornost za bilo kakve povrede."
                            }
                        },
                        "button": {
                            "cancel": "Otkaži",
                            "confirm": "Potvrdi i prihvati"
                        }
                    },
                    "takedown": {
                        "header": "Jeste li sigurni da želite ukloniti ovo izdanje iz svih trgovina?",
                        "description": {
                            "point1": "Ova akcija je nepovratna.",
                            "point2": "Uklanjanjem ovog izdanja, pridržavate se <1>Uvjeta distribucije</1>, <3>Uvjeta korištenja</3> i <5>Pravila o privatnosti</5>."
                        },
                        "button": {
                            "cancel": "Otkaži",
                            "confirm": "Potvrdi i prihvati"
                        }
                    },
                    "finishEditing": {
                        "header": "Jeste li sigurni da su svi uneseni podaci valjani i potpuno predstavljaju ovo izdanje?",
                        "description": {
                            "point1": "Nakon ove akcije, vaše izdanje će biti provjereno i ako su podaci točni, bit će ponovno distribuirano DSP partnerima. <strong>NAPOMENA, samo METAPODACI će biti poslani DSP-ovima, sadržaj kao što su SLIKE i AUDIO datoteke ne mogu se ažurirati na ovaj način.</strong>",
                            "point2": "Potvrdom i prihvaćanjem ovog obrasca, u potpunosti prihvaćate i pridržavate se <1>Uvjeta korištenja</1> i Uvjeta našeg Ekskluzivnog ugovora o distribuciji.",
                            "point3": "Potvrdom i prihvaćanjem ovog obrasca, u potpunosti prihvaćate i pridržavate se <1>Pravila o privatnosti</1>.",
                            "point4": "Potvrdom i prihvaćanjem ovog obrasca, nesporno potvrđujete da vam sadržaj izdanja s pripadajućim sredstvima, audio datotekama i metapodacima, ili isključivo pripada ili je potpuno licenciran vašoj etiketi.",
                            "point5": "Ovim u potpunosti prihvaćate da ćete biti isključivo odgovorni za bilo kakve obmanjujuće informacije, nelicenciranu upotrebu, nezakonite aktivnosti ili bilo kakve sporove."
                        },
                        "button": {
                            "cancel": "Otkaži",
                            "confirm": "Potvrdi i prihvati"
                        }
                    }
                }
            },
            "message": {
                "success": "Izdanje ažurirano!",
                "declaration_success": "Izjava podnesena na pregled administratoru.",
                "declaration_error": "Nešto je pošlo po zlu prilikom podnošenja izjave, pokušajte ponovo kasnije.",
                "pre_scan_declaration_success": "Pre Scan izjava poslana uspješno.",
                "pre_scan_declaration_error": "Nešto je pošlo po zlu prilikom podnošenja Pre Scan izjave, pokušajte ponovo kasnije.",
                "pre_scan_success": "Izdanje uspješno poslano za skeniranje.",
                "pre_scan_error": "Nešto je pošlo po zlu prilikom skeniranja izdanja, pokušajte ponovo kasnije.",
                "linkCopied": "Link kopiran u međuspremnik!"
            }
        },
        "message": {
            "trackDistributionAllowanceSpent": "Potrošili ste svoju kvotu za distribuciju pjesama. Da biste prenijeli više pjesama, nadogradite svoj račun ili kontaktirajte naš tim za podršku.",
            "subscriptionUpgrade": "Vaš trenutni plan pretplate ne podržava ovu značajku. Molimo <1>nadogradite</1> svoj plan pretplate kako biste iskoristili ovu značajku.",
            "subscriptionExpired": "Vaša pretplata je istekla. Molimo <1>nastavite</1> svoju pretplatu kako biste iskoristili ovu značajku.",
            "noAccess": "Nemate pristup ovom modulu, molimo kontaktirajte tim za podršku za više informacija.",
            "subscriptionUpgradeReleaseTransfer": "Vaš trenutni plan pretplate ne podržava značajku prijenosa izdanja. Ako prenosite veći katalog ili želite prenijeti više kataloga diskografskih kuća na Music Link samo s nekoliko klikova, molimo <1>nadogradite</1> svoj plan pretplate.",
            "noAccessReleaseTransfer": "Trenutno nemate dopuštenje za korištenje značajke prijenosa izdanja. Ako prenosite veći katalog ili želite prenijeti više kataloga diskografskih kuća na Music Link samo s nekoliko klikova, ne ustručavajte se kontaktirati naš tim za podršku.",
            "accountBlacklisted": "Vaš račun je bio blacklisted nakon pregleda kako smo otkrili da su informacije povezane s vašim računom povezane s jednim od internacionalno blacklisted korisnika u našem sistemu. Stoga smo onemogućili funkciju distribucije za vaš račun.",
        }
    },
    "add": {
        "title": "Dodaj novo izdanje",
        "form": {
            "label": {
                "required": "Obavezno",
                "name": "Naziv izdanja",
                "version": "Verzija izdanja",
                "subuser": "Pod-korisnik",
                "label": "Etiketa",
                "copyright": "Autorska prava ©",
                "copyright_year": "Godina autorskih prava ©",
                "copyright_publisher": "Autorska prava ℗",
                "copyright_publisher_year": "Godina autorskih prava ℗",
                "genre": "Žanr",
                "subgenre": "Podžanr",
                "catalog_number": "Kataloški broj",
                "artwork": "Umjetničko djelo",
                "artwork_alt": "Vaše umjetničko djelo",
                "new_release": "Je li ovo novo izdanje?",
                "original_release_date": "Izvorni datum izdanja",
                "official_release_date": "Službeni datum izdanja",
                "backcatalog": "Povratni katalog",
                "assisted_dates": "Pomoćni datumi",
                "exclusive_store_release_date": "Ekskluzivni datum izdanja u trgovini",
                "additional_metadata": "Dodatni metapodaci",
                "release_description": "Opis izdanja",
                "release_language": "Jezik naziva izdanja",
                "auto_detect_language": "Automatski otkrij (jezik)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Automatski generiraj (ean)",
                "territories": "Teritoriji",
                "countries": "Zemlje",
                "youtube_declaration_header": "IZJAVA O YOUTUBE CONTENT ID",
                "youtube_declaration_intro": "Da biste se prijavili za YouTube Content ID za ovo izdanje, morate osigurati da ispunjavate SVE sljedeće zahtjeve:",
                "youtube_declaration_certify": "Ja, <strong>{{firstName}} {{lastName}}</strong>, pod kaznom krivokletstva, ovime potvrđujem da su prethodne informacije istinite i točne.",
                "youtube_declaration_point1": "Imam dovoljno prava na materijal.",
                "youtube_declaration_point2": "Sav referentni sadržaj je dovoljno prepoznatljiv.",
                "youtube_declaration_point3": "Imam pojedinačne reference za svaki dio intelektualnog vlasništva.",
                "youtube_declaration_point4": "Dostavljeni sadržaj <strong>nije</strong> nijedan od sljedećih: javno vlasništvo, neekskluzivno licencirani sadržaj, isječci iz drugih izvora korišteni prema načelima poštene upotrebe, video snimke igranja (osim od izdavača igre), karaoke snimke, remaster bez dopuštenja, snimke slične zvuku, sinkronizirani sadržaj, ubrzanje/usporavanje, zvučni efekti, zvučni kreveti, kontinuirani DJ miksevi, mashupovi, odbrojavanje popisa ili bilo koji drugi zabranjeni ili neprihvatljivi sadržaj naveden u YouTubeovim smjernicama za Content ID u nastavku.",
                "youtube_declaration_account": "Razumijem da moj račun može biti deaktiviran i ukinut u slučaju bilo kakvih kršenja. Nadalje, potpuno razumijem da mogu biti odgovoran za bilo kakve naknade, štete, pravne troškove ili bilo koje druge troškove koji mogu nastati.",
                "youtube_declaration_guidelines": "Prema <1><strong>YouTubeovim smjernicama za Content ID</strong></1>, sadržaj dostavljen putem ovog izdanja potpuno je prihvatljiv za YouTube Content ID.",
                "youtube_content_id_eligible": "Potvrđujem da je moj sadržaj prihvatljiv za <strong>YouTube Content ID</strong>",
                "youtube_content_id_not_eligible": "Moj sadržaj nije prihvatljiv za <strong>YouTube Content ID</strong>",
                "immersive_audio": "Ovo izdanje ima imerzivni zvuk"
            },
            "placeholder": {
                "version": "Ostavite prazno ako niste sigurni ili ako je ovo redovno izdanje",
                "select_date": "Odaberite datum...",
                "copyright": "Obično naziv vaše etikete",
                "copyright_publisher": "Obično naziv vaše etikete",
                "copyright_year": "GGGG",
                "copyright_year_publisher": "GGGG",
                "catalog_number": "Unesite svoj kataloški broj. Obično etikete unose skraćenicu naziva etikete i broj. Npr. {{prefix}}001, {{prefix}}002...",
                "label": "Odaberite etiketu...",
                "subuser": "Odaberite pod-korisnika...",
                "genre": "Odaberite žanr...",
                "subgenre": "Odaberite podžanr...",
                "ean": "Ostavite prazno ako niste sigurni!",
                "release_description": "Nekoliko riječi o vašem izdanju. Molimo bez linkova i e-mail adresa. Maksimalno 600 znakova"
            },
            "help_text": {
                "name": "Molimo ne koristite dodatke nazivu izdanja kao što su LP i EP.",
                "version": "Neka izdanja se izdaju u više verzija, ako je tako, unesite naziv verzije. Ako je vaše izdanje originalno/standardno izdanje, zanemarite ovo polje.",
                "subuser": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izdanje za bilo kojeg od svojih pod-korisnika, inače ostavite neizabrano.",
                "label": "Napomena: Molimo odaberite svoju etiketu iz padajućeg izbornika ako već postoji u sustavu, inače kreirajte svoju etiketu klikom <1>ovdje</1>, nakon što je kreirana, možete je odabrati iz padajućeg izbornika.",
                "catalog_number": "Unesite svoj kataloški broj. Obično etikete unose skraćenicu naziva etikete i broj. Npr. {{prefix}}001, {{prefix}}002...",
                "artwork": "Prenesite JPG formate, rezolucija samo 3000x3000 px, @ 72 dpi",
                "original_release_date": "Izvorni datum izdanja za sve trgovine širom svijeta.",
                "official_release_date": "Službeni datum izdanja za sve trgovine širom svijeta.",
                "release_language": "Na kojem je jeziku napisan naziv izdanja? Molimo dvaput provjerite ako niste sigurni. Ako je ovaj unos pogrešan, neke trgovine poput iTunesa i Apple Musica odbit će izdanje.",
                "ean": "Univerzalni kod proizvoda ili europski broj artikla za izdanje. Valjani kodovi su 13 znamenki. Ako nemate svoj, generirat ćemo ga za vas."
            },
            "option": {
                "yes": "Da",
                "no": "Ne",
                "no_exclusive": "Bez ekskluzive",
                "beatport_2weeks": "Beatport 2 tjedna",
                "beatport_4weeks": "Beatport 4 tjedna",
                "preorder_1week": "Prednarudžba 1 tjedan",
                "preorder_2weeks": "Prednarudžba 2 tjedna",
                "traxsource_2weeks": "Traxsource 2 tjedna",
                "select": "Odaberite...",
                "worldwide": "Širom svijeta",
                "only_selected": "Samo odabrane zemlje",
                "all_except_selected": "Sve osim odabranih zemalja"
            },
            "message": {
                "track_name_required": "Molimo unesite naziv pjesme",
                "mix_name_required": "Molimo unesite naziv miksa",
                "mix_name_invalid": "Naziv miksa može se sastojati samo od slova, brojeva, razmaka i podvlake",
                "artist_required": "Molimo odaberite umjetnika",
                "artist_type_required": "Molimo odaberite vrstu umjetnika",
                "catalog_duplicate": "Kataloški broj '{{number}}' je već korišten. Molimo unesite drugi.",
                "ean_duplicate": "Ovaj EAN broj je povezan s drugim izdanjem. Molimo unesite drugi.",
                "artist_added": "Novi umjetnik je dodan!",
                "track_limit": "Vaša trenutna kvota za pjesme je nedovoljna. Molimo nadogradite svoj račun ili kontaktirajte podršku.",
                "select_day": "Molimo odaberite dan.",
                "form_error": "Obrazac se ne može poslati! Molimo ispunite sva polja i provjerite pogreške!",
                "ean_invalid": "Vrijednost nije valjan EAN. Ako unosite novo izdanje, ostavite ovo polje prazno i mi ćemo generirati EAN za vas. Ako prenosite povratni katalog i EAN nije valjan, molimo kontaktirajte nas.",
                "ean_length": "EAN broj mora imati 13 znakova",
                "artwork_invalid": "Ova datoteka nije valjana, molimo provjerite da slika ima .jpg ekstenziju, RGB boje, dimenzije 3000 X 3000 i do 4MB.",
                "track_invalid": "Ova datoteka nije valjana, molimo provjerite da je datoteka pravilno kodirana u 16 bit, 44.1 Khz.",
                "artworkSwapTokenRequiredTooltip": "Vaš trenutni saldo tokena nije dovoljan. Potreban je najmanje 1 token za zamjenu naslovne slike."
            },
            "button": {
                "reset": "Resetiraj",
                "save_only": "Samo spremi",
                "save_and_continue": "Spremi i nastavi"
            },
            "modal": {
                "assisted_days": {
                    "header": "Jeste li sigurni da želite ignorirati najbolje prakse za datum izdanja?",
                    "body": "Napomena: odabirom ove opcije, vaš datum izdanja možda neće biti prihvaćen od strane trgovina ili unesen i objavljen na odabrani datum. Osim toga, značajno smanjujete marketinške mogućnosti.",
                    "button": {
                        "cancel": "Otkaži",
                        "confirm": "Potvrdi"
                    }
                },
                "release_created": {
                    "header": "Izdanje kreirano!",
                    "body": "Vaše izdanje je uspješno kreirano!",
                    "button": {
                        "close": "Zatvori"
                    }
                }
            }
        }
    },
    "update": {
        "title": "Ažuriraj izdanje",
        "form": {
            "label": {
                "required": "Obavezno",
                "name": "Naziv izdanja",
                "version": "Verzija izdanja",
                "subuser": "Pod-korisnik",
                "label": "Etiketa",
                "copyright": "Autorska prava ©",
                "copyright_year": "Godina autorskih prava ©",
                "copyright_publisher": "Autorska prava ℗",
                "copyright_publisher_year": "Godina autorskih prava ℗",
                "genre": "Žanr",
                "subgenre": "Podžanr",
                "catalog_number": "Kataloški broj",
                "artwork": "Umjetničko djelo",
                "artwork_alt": "Vaše umjetničko djelo",
                "new_release": "Je li ovo novo izdanje?",
                "original_release_date": "Izvorni datum izdanja",
                "official_release_date": "Službeni datum izdanja",
                "backcatalog": "Povratni katalog",
                "assisted_dates": "Pomoćni datumi",
                "exclusive_store_release_date": "Ekskluzivni datum izdanja u trgovini",
                "additional_metadata": "Dodatni metapodaci",
                "release_description": "Opis izdanja",
                "release_language": "Jezik naziva izdanja",
                "auto_detect_language": "Automatski otkrij (jezik)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Automatski generiraj (ean)",
                "territories": "Teritoriji",
                "countries": "Zemlje",
                "youtube_declaration_header": "IZJAVA O YOUTUBE CONTENT ID",
                "youtube_declaration_intro": "Da biste se prijavili za YouTube Content ID za ovo izdanje, morate osigurati da ispunjavate SVE sljedeće zahtjeve:",
                "youtube_declaration_certify": "Ja, <strong>{{firstName}} {{lastName}}</strong>, pod kaznom krivokletstva, ovime potvrđujem da su prethodne informacije istinite i točne.",
                "youtube_declaration_point1": "Imam dovoljno prava na materijal.",
                "youtube_declaration_point2": "Sav referentni sadržaj je dovoljno prepoznatljiv.",
                "youtube_declaration_point3": "Imam pojedinačne reference za svaki dio intelektualnog vlasništva.",
                "youtube_declaration_point4": "Dostavljeni sadržaj <strong>nije</strong> nijedan od sljedećih: javno vlasništvo, neekskluzivno licencirani sadržaj, isječci iz drugih izvora korišteni prema načelima poštene upotrebe, video snimke igranja (osim od izdavača igre), karaoke snimke, remaster bez dopuštenja, snimke slične zvuku, sinkronizirani sadržaj, ubrzanje/usporavanje, zvučni efekti, zvučni kreveti, kontinuirani DJ miksevi, mashupovi, odbrojavanje popisa ili bilo koji drugi zabranjeni ili neprihvatljivi sadržaj naveden u YouTubeovim smjernicama za Content ID u nastavku.",
                "youtube_declaration_account": "Razumijem da moj račun može biti deaktiviran i ukinut u slučaju bilo kakvih kršenja. Nadalje, potpuno razumijem da mogu biti odgovoran za bilo kakve naknade, štete, pravne troškove ili bilo koje druge troškove koji mogu nastati.",
                "youtube_declaration_guidelines": "Prema <1><strong>YouTubeovim smjernicama za Content ID</strong></1>, sadržaj dostavljen putem ovog izdanja potpuno je prihvatljiv za YouTube Content ID.",
                "youtube_content_id_eligible": "Potvrđujem da je moj sadržaj prihvatljiv za <strong>YouTube Content ID</strong>",
                "youtube_content_id_not_eligible": "Moj sadržaj nije prihvatljiv za <strong>YouTube Content ID</strong>",
                "immersive_audio": "Ovo izdanje ima imerzivni zvuk"
            },
            "placeholder": {
                "version": "Ostavite prazno ako niste sigurni ili ako je ovo redovno izdanje",
                "select_date": "Odaberite datum...",
                "copyright": "Obično naziv vaše etikete",
                "copyright_publisher": "Obično naziv vaše etikete",
                "copyright_year": "GGGG",
                "copyright_year_publisher": "GGGG",
                "catalog_number": "Unesite svoj kataloški broj. Obično etikete unose skraćenicu naziva etikete i broj. Npr. {{prefix}}001, {{prefix}}002...",
                "label": "Odaberite etiketu...",
                "subuser": "Odaberite pod-korisnika...",
                "genre": "Odaberite žanr...",
                "subgenre": "Odaberite podžanr...",
                "ean": "Ostavite prazno ako niste sigurni!",
                "release_description": "Nekoliko riječi o vašem izdanju. Molimo bez linkova i e-mail adresa. Maksimalno 600 znakova"
            },
            "help_text": {
                "name": "Molimo ne koristite dodatke nazivu izdanja kao što su LP i EP.",
                "version": "Neka izdanja se izdaju u više verzija, ako je tako, unesite naziv verzije. Ako je vaše izdanje originalno/standardno izdanje, zanemarite ovo polje.",
                "subuser": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izdanje za bilo kojeg od svojih pod-korisnika, inače ostavite neizabrano.",
                "label": "Napomena: Molimo odaberite svoju etiketu iz padajućeg izbornika ako već postoji u sustavu, inače kreirajte svoju etiketu klikom <1>ovdje</1>, nakon što je kreirana, možete je odabrati iz padajućeg izbornika.",
                "catalog_number": "Unesite svoj kataloški broj. Obično etikete unose skraćenicu naziva etikete i broj. Npr. {{prefix}}001, {{prefix}}002...",
                "artwork": "Prenesite JPG formate, rezolucija samo 3000x3000 px, @ 72 dpi",
                "original_release_date": "Izvorni datum izdanja za sve trgovine širom svijeta.",
                "official_release_date": "Službeni datum izdanja za sve trgovine širom svijeta.",
                "release_language": "Na kojem je jeziku napisan naziv izdanja? Molimo dvaput provjerite ako niste sigurni. Ako je ovaj unos pogrešan, neke trgovine poput iTunesa i Apple Musica odbit će izdanje.",
                "ean": "Univerzalni kod proizvoda ili europski broj artikla za izdanje. Valjani kodovi su 13 znamenki. Ako nemate svoj, generirat ćemo ga za vas."
            },
            "option": {
                "yes": "Da",
                "no": "Ne",
                "no_exclusive": "Bez ekskluzive",
                "beatport_2weeks": "Beatport 2 tjedna",
                "beatport_4weeks": "Beatport 4 tjedna",
                "preorder_1week": "Prednarudžba 1 tjedan",
                "preorder_2weeks": "Prednarudžba 2 tjedna",
                "traxsource_2weeks": "Traxsource 2 tjedna",
                "select": "Odaberite...",
                "worldwide": "Širom svijeta",
                "only_selected": "Samo odabrane zemlje",
                "all_except_selected": "Sve osim odabranih zemalja"
            },
            "message": {
                "track_name_required": "Molimo unesite naziv pjesme",
                "mix_name_required": "Molimo unesite naziv miksa",
                "mix_name_invalid": "Naziv miksa može se sastojati samo od slova, brojeva, razmaka i podvlake",
                "artist_required": "Molimo odaberite umjetnika",
                "artist_type_required": "Molimo odaberite vrstu umjetnika",
                "catalog_duplicate": "Kataloški broj '{{number}}' je već korišten. Molimo unesite drugi.",
                "ean_duplicate": "Ovaj EAN broj je povezan s drugim izdanjem. Molimo unesite drugi.",
                "artist_added": "Novi umjetnik je dodan!",
                "track_limit": "Vaša trenutna kvota za pjesme je {{trackLimit}} pjesama. Da biste prenijeli više pjesama, nadogradite svoj račun ili kontaktirajte naš tim za podršku.",
                "select_day": "Molimo odaberite dan.",
                "form_error": "Obrazac se ne može poslati! Molimo ispunite sva polja i provjerite pogreške!",
                "ean_invalid": "Vrijednost nije valjan EAN. Ako unosite novo izdanje, ostavite ovo polje prazno i mi ćemo generirati EAN za vas. Ako prenosite povratni katalog i EAN nije valjan, molimo kontaktirajte nas.",
                "ean_length": "EAN broj mora imati 13 znakova",
                "artwork_invalid": "Ova datoteka nije valjana, molimo provjerite da slika ima .jpg ekstenziju, RGB boje, dimenzije 3000 X 3000 i do 4MB.",
                "track_invalid": "Ova datoteka nije valjana, molimo provjerite da je datoteka pravilno kodirana u 16 bit, 44.1 Khz."
            },
            "button": {
                "reset": "Resetiraj",
                "submit_form": "Pošalji obrazac",
                "save_and_continue": "Spremi i nastavi"
            },
            "modal": {
                "assisted_days": {
                    "header": "Jeste li sigurni da želite ignorirati najbolje prakse za datum izdanja?",
                    "body": "Napomena: odabirom ove opcije, vaš datum izdanja možda neće biti prihvaćen od strane trgovina ili unesen i objavljen na odabrani datum. Osim toga, značajno smanjujete marketinške mogućnosti.",
                    "button": {
                        "cancel": "Otkaži",
                        "confirm": "Potvrdi"
                    }
                },
                "release_updated": {
                    "header": "Izdanje ažurirano!",
                    "body": "Vaše izdanje je uspješno ažurirano!",
                    "button": {
                        "close": "Zatvori"
                    }
                }
            }
        }
    },
    "transfer": {
        "title": "Prijenos izdanja",
        "view": {
            "title": "Prijenos izdanja",
            "label": {
                "searchBy": "Pretraži po",
                "upc": "UPC broj",
                "url": "URL izdanja u trgovini",
                "name": "Naziv izdanja",
                "spotify": "Spotify",
                "deezer": "Deezer",
                "fetchReleaseDetails": "Dohvaćanje detalja izdanja..."
            },
            "placeholder": {
                "upc": "Unesite UPC/EAN broj izdanja npr. 5055964352523",
                "url": "Unesite URL izdanja u trgovini npr. open.spotify.com/album/4pAD0l5icphM5TC1A4q8Yn ili www.deezer.com/en/album/413370367",
                "name": "Unesite naziv izdanja npr. Warrior"
            },
            "help_text": {
                "upc": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izdanje koje je već na Spotifyju ili Deezeru.",
                "url": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izdanje koje je već na Spotifyju ili Deezeru.",
                "name_spotify": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izdanje koje je već na Spotifyju.",
                "name_deezer": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izdanje koje je već na Deezeru."
            },
            "button": {
                "reset": "Resetiraj",
                "transfer": "Prenesi"
            },
            "message": {
                "release_exists": "Izdanje s ovim UPC brojem već pripada drugom korisniku unutar platforme Music Link. Molimo uvezite samo izdanja koja u potpunosti pripadaju vašoj tvrtki i etiketi. Ako vjerujete da je netko uzeo vaše izdanje bez dopuštenja, molimo kontaktirajte naš tim za podršku."
            }
        },
        "modal": {
            "header": "Uvjeti prijenosa izdanja",
            "ownership_warranty": {
                "header": "Jamstvo vlasništva",
                "body": {
                    "point1": "Prihvaćanjem ovih uvjeta, potvrđujete i jamčite da imate zakonito vlasništvo ili predstavljate zakonitog vlasnika svih sadržaja, uključujući izdanje i pridružene pjesme, navedene ovdje.",
                    "point2": "Potvrđujete da nijedan zaštićeni materijal ili intelektualno vlasništvo treće strane nije uključeno u ovo izdanje."
                }
            },
            "non_infringement_warranty": {
                "header": "Jamstvo nekršenja",
                "body": {
                    "point1": "Nastavljajući, izričito potvrđujete da sadržaj dostavljen u ovom izdanju ne krši prava trećih strana, uključujući, ali ne ograničavajući se na autorska prava, zaštitne znakove ili bilo koja druga vlasnička prava.",
                    "point2": "Slažete se da nećete uključivati materijal iz vanjskih izvora bez odgovarajuće autorizacije."
                }
            },
            "exclusivity_declaration": {
                "header": "Izjava o ekskluzivnosti",
                "body": {
                    "point1": "Prihvaćanjem ovih uvjeta, obvezujete se da je sadržaj predstavljen u ovom izdanju isključivo vaše vlasništvo ili autorizirano predstavljanje, te da nije ponuđen ili izdan bilo kojoj drugoj entitetu ili platformi.",
                    "point2": "Preuzimate punu odgovornost za bilo kakvo kršenje ekskluzivnosti i razumijete da bilo kakvo takvo kršenje može dovesti do pravnih posljedica."
                }
            },
            "legal_consequences_awareness": {
                "header": "Svijest o pravnim posljedicama",
                "body": {
                    "point1": "Ključno je razumjeti da bilo kakvo kršenje uvjeta i jamstava navedenih u ovom modalu ili uvjetima može dovesti do ozbiljnih pravnih posljedica.",
                    "point2": "Ove kazne mogu uključivati, ali nisu ograničene na, značajne financijske obveze, pravne zabrane i štetu reputaciji.",
                    "point3": "Prihvaćanjem ovih uvjeta, priznajete ozbiljnost pridržavanja navedenih obveza i prepoznajete da nepoštivanje može rezultirati pravnim postupcima protiv vas ili vaše organizacije."
                }
            },
            "button": {
                "cancel": "Otkaži",
                "agree": "Slažem se"
            }
        },
        "form": {
            "title": "Prijenos izdanja",
            "label": {
                "required": "Obavezno",
                "name": "Naziv izdanja",
                "version": "Verzija izdanja",
                "subuser": "Pod-korisnik",
                "label": "Etiketa",
                "copyright": "Autorska prava ©",
                "copyright_year": "Godina autorskih prava ©",
                "copyright_publisher": "Autorska prava ℗",
                "copyright_publisher_year": "Godina autorskih prava ℗",
                "genre": "Žanr",
                "subgenre": "Podžanr",
                "catalog_number": "Kataloški broj",
                "artwork": "Umjetničko djelo",
                "artwork_alt": "Vaše umjetničko djelo",
                "new_release": "Je li ovo novo izdanje?",
                "original_release_date": "Izvorni datum izdanja",
                "official_release_date": "Službeni datum izdanja",
                "backcatalog": "Povratni katalog",
                "assisted_dates": "Pomoćni datumi",
                "exclusive_store_release_date": "Ekskluzivni datum izdanja u trgovini",
                "additional_metadata": "Dodatni metapodaci",
                "release_description": "Opis izdanja",
                "release_language": "Jezik naziva izdanja",
                "auto_detect_language": "Automatski otkrij (jezik)",
                "ean": "EAN / UPC",
                "territories": "Teritoriji",
                "countries": "Zemlje",
                "youtube_declaration_header": "IZJAVA O YOUTUBE CONTENT ID",
                "youtube_declaration_intro": "Da biste se prijavili za YouTube Content ID za ovo izdanje, morate osigurati da ispunjavate SVE sljedeće zahtjeve:",
                "youtube_declaration_certify": "Ja, <strong>{{firstName}} {{lastName}}</strong>, pod kaznom krivokletstva, ovime potvrđujem da su prethodne informacije istinite i točne.",
                "youtube_declaration_point1": "Imam dovoljno prava na materijal.",
                "youtube_declaration_point2": "Sav referentni sadržaj je dovoljno prepoznatljiv.",
                "youtube_declaration_point3": "Imam pojedinačne reference za svaki dio intelektualnog vlasništva.",
                "youtube_declaration_point4": "Dostavljeni sadržaj <strong>nije</strong> nijedan od sljedećih: javno vlasništvo, neekskluzivno licencirani sadržaj, isječci iz drugih izvora korišteni prema načelima poštene upotrebe, video snimke igranja (osim od izdavača igre), karaoke snimke, remaster bez dopuštenja, snimke slične zvuku, sinkronizirani sadržaj, ubrzanje/usporavanje, zvučni efekti, zvučni kreveti, kontinuirani DJ miksevi, mashupovi, odbrojavanje popisa ili bilo koji drugi zabranjeni ili neprihvatljivi sadržaj naveden u YouTubeovim smjernicama za Content ID u nastavku.",
                "youtube_declaration_account": "Razumijem da moj račun može biti deaktiviran i ukinut u slučaju bilo kakvih kršenja. Nadalje, potpuno razumijem da mogu biti odgovoran za bilo kakve naknade, štete, pravne troškove ili bilo koje druge troškove koji mogu nastati.",
                "youtube_declaration_guidelines": "Prema <1><strong>YouTubeovim smjernicama za Content ID</strong></1>, sadržaj dostavljen putem ovog izdanja potpuno je prihvatljiv za YouTube Content ID.",
                "youtube_content_id_eligible": "Potvrđujem da je moj sadržaj prihvatljiv za <strong>YouTube Content ID</strong>",
                "youtube_content_id_not_eligible": "Moj sadržaj nije prihvatljiv za <strong>YouTube Content ID</strong>",
                "immersive_audio": "Ovo izdanje ima imerzivni zvuk"
            },
            "placeholder": {
                "version": "Ostavite prazno ako niste sigurni ili ako je ovo redovno izdanje",
                "select_date": "Odaberite datum...",
                "copyright": "Obično naziv vaše etikete",
                "copyright_publisher": "Obično naziv vaše etikete",
                "copyright_year": "GGGG",
                "copyright_year_publisher": "GGGG",
                "catalog_number": "Unesite svoj kataloški broj. Obično etikete unose skraćenicu naziva etikete i broj. Npr. {{prefix}}001, {{prefix}}002...",
                "label": "Odaberite etiketu...",
                "subuser": "Odaberite pod-korisnika...",
                "genre": "Odaberite žanr...",
                "subgenre": "Odaberite podžanr...",
                "ean": "Ostavite prazno ako niste sigurni!",
                "release_description": "Nekoliko riječi o vašem izdanju. Molimo bez linkova i e-mail adresa. Maksimalno 600 znakova"
            },
            "help_text": {
                "name": "Molimo ne koristite dodatke nazivu izdanja kao što su LP i EP.",
                "version": "Neka izdanja se izdaju u više verzija, ako je tako, unesite naziv verzije. Ako je vaše izdanje originalno/standardno izdanje, zanemarite ovo polje.",
                "subuser": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izdanje za bilo kojeg od svojih pod-korisnika, inače ostavite neizabrano.",
                "label": "Napomena: Molimo odaberite svoju etiketu <strong>{{labelName}}</strong> iz padajućeg izbornika ako već postoji u sustavu, inače kreirajte svoju etiketu <strong>{{labelName}}</strong> klikom <5>ovdje</5>, nakon što je kreirana, možete je odabrati iz padajućeg izbornika.",
                "catalog_number": "Unesite svoj kataloški broj. Obično etikete unose skraćenicu naziva etikete i broj. Npr. {{prefix}}001, {{prefix}}002...",
                "artwork": "Prenesite JPG formate, rezolucija samo 3000x3000 px, @ 72 dpi",
                "original_release_date": "Izvorni datum izdanja za sve trgovine širom svijeta.",
                "official_release_date": "Službeni datum izdanja za sve trgovine širom svijeta.",
                "release_language": "Na kojem je jeziku napisan naziv izdanja? Molimo dvaput provjerite ako niste sigurni. Ako je ovaj unos pogrešan, neke trgovine poput iTunesa i Apple Musica odbit će izdanje.",
                "ean": "Univerzalni kod proizvoda ili europski broj artikla za izdanje. Valjani kodovi su 13 znamenki. Ako nemate svoj, generirat ćemo ga za vas."
            },
            "option": {
                "yes": "Da",
                "no": "Ne",
                "no_exclusive": "Bez ekskluzive",
                "beatport_2weeks": "Beatport 2 tjedna",
                "beatport_4weeks": "Beatport 4 tjedna",
                "preorder_1week": "Prednarudžba 1 tjedan",
                "preorder_2weeks": "Prednarudžba 2 tjedna",
                "traxsource_2weeks": "Traxsource 2 tjedna",
                "select": "Odaberite...",
                "worldwide": "Širom svijeta",
                "only_selected": "Samo odabrane zemlje",
                "all_except_selected": "Sve osim odabranih zemalja"
            },
            "message": {
                "track_name_required": "Molimo unesite naziv pjesme",
                "mix_name_required": "Molimo unesite naziv miksa",
                "mix_name_invalid": "Naziv miksa može se sastojati samo od slova, brojeva, razmaka i podvlake",
                "artist_required": "Molimo odaberite umjetnika",
                "artist_type_required": "Molimo odaberite vrstu umjetnika",
                "catalog_duplicate": "Kataloški broj '{{number}}' je već korišten. Molimo unesite drugi.",
                "artist_added": "Novi umjetnik je dodan!",
                "track_limit": "Vaša trenutna kvota za pjesme je {{trackLimit}} pjesama. Da biste prenijeli više pjesama, nadogradite svoj račun ili kontaktirajte naš tim za podršku.",
                "select_day": "Molimo odaberite dan.",
                "form_error": "Obrazac se ne može poslati! Molimo ispunite sva polja i provjerite pogreške!",
                "ean_invalid": "Vrijednost nije valjan EAN. Ako unosite novo izdanje, ostavite ovo polje prazno i mi ćemo generirati EAN za vas. Ako prenosite povratni katalog i EAN nije valjan, molimo kontaktirajte nas.",
                "ean_length": "EAN broj mora imati 13 znakova",
                "artwork_invalid": "Ova datoteka nije valjana, molimo provjerite da slika ima .jpg ekstenziju, RGB boje, dimenzije 3000 X 3000 i do 4MB.",
                "track_invalid": "Ova datoteka nije valjana, molimo provjerite da je datoteka pravilno kodirana u 16 bit, 44.1 Khz."
            },
            "button": {
                "reset": "Resetiraj",
                "save_only": "Samo spremi",
                "save_and_continue": "Spremi i nastavi"
            },
            "modal": {
                "assisted_days": {
                    "header": "Jeste li sigurni da želite ignorirati najbolje prakse za datum izdanja?",
                    "body": "Napomena: odabirom ove opcije, vaš datum izdanja možda neće biti prihvaćen od strane trgovina ili unesen i objavljen na odabrani datum. Osim toga, značajno smanjujete marketinške mogućnosti.",
                    "button": {
                        "cancel": "Otkaži",
                        "confirm": "Potvrdi"
                    }
                },
                "release_created": {
                    "header": "Izdanje kreirano!",
                    "body": "Vaše izdanje je uspješno kreirano!",
                    "button": {
                        "close": "Zatvori"
                    }
                },
                "release_transfer_declaration": {
                    "header": "Izjava o prijenosu izdanja",
                    "body": "Provjerio sam i ispunio sve potrebne informacije za ovo izdanje i sada je spremno za UPLOAD.",
                    "button": {
                        "cancel": "Otkaži",
                        "confirm": "Potvrdi"
                    }
                }
            }
        }
    },
    "viewDetails": {
        "title": "Pregledaj izdanje",
        "form": {
            "label": {
                "required": "Obavezno",
                "name": "Naziv izdanja",
                "version": "Verzija izdanja",
                "subuser": "Pod-korisnik",
                "label": "Etiketa",
                "copyright": "Autorska prava ©",
                "copyright_year": "Godina autorskih prava ©",
                "copyright_publisher": "Autorska prava ℗",
                "copyright_publisher_year": "Godina autorskih prava ℗",
                "genre": "Žanr",
                "subgenre": "Podžanr",
                "catalog_number": "Kataloški broj",
                "artwork": "Umjetničko djelo",
                "artwork_alt": "Vaše umjetničko djelo",
                "new_release": "Je li ovo novo izdanje?",
                "original_release_date": "Izvorni datum izdanja",
                "official_release_date": "Službeni datum izdanja",
                "backcatalog": "Povratni katalog",
                "assisted_dates": "Pomoćni datumi",
                "exclusive_store_release_date": "Ekskluzivni datum izdanja u trgovini",
                "additional_metadata": "Dodatni metapodaci",
                "release_description": "Opis izdanja",
                "release_language": "Jezik naziva izdanja",
                "auto_detect_language": "Automatski otkrij (jezik)",
                "ean": "EAN / UPC",
                "auto_generate_ean": "Automatski generiraj (ean)",
                "territories": "Teritoriji",
                "countries": "Zemlje",
                "youtube_declaration_header": "IZJAVA O YOUTUBE CONTENT ID",
                "youtube_declaration_intro": "Da biste se prijavili za YouTube Content ID za ovo izdanje, morate osigurati da ispunjavate SVE sljedeće zahtjeve:",
                "youtube_declaration_certify": "Ja, <strong>{{firstName}} {{lastName}}</strong>, pod kaznom krivokletstva, ovime potvrđujem da su prethodne informacije istinite i točne.",
                "youtube_declaration_point1": "Imam dovoljno prava na materijal.",
                "youtube_declaration_point2": "Sav referentni sadržaj je dovoljno prepoznatljiv.",
                "youtube_declaration_point3": "Imam pojedinačne reference za svaki dio intelektualnog vlasništva.",
                "youtube_declaration_point4": "Dostavljeni sadržaj <strong>nije</strong> nijedan od sljedećih: javno vlasništvo, neekskluzivno licencirani sadržaj, isječci iz drugih izvora korišteni prema načelima poštene upotrebe, video snimke igranja (osim od izdavača igre), karaoke snimke, remaster bez dopuštenja, snimke slične zvuku, sinkronizirani sadržaj, ubrzanje/usporavanje, zvučni efekti, zvučni kreveti, kontinuirani DJ miksevi, mashupovi, odbrojavanje popisa ili bilo koji drugi zabranjeni ili neprihvatljivi sadržaj naveden u YouTubeovim smjernicama za Content ID u nastavku.",
                "youtube_declaration_account": "Razumijem da moj račun može biti deaktiviran i ukinut u slučaju bilo kakvih kršenja. Nadalje, potpuno razumijem da mogu biti odgovoran za bilo kakve naknade, štete, pravne troškove ili bilo koje druge troškove koji mogu nastati.",
                "youtube_declaration_guidelines": "Prema <1><strong>YouTubeovim smjernicama za Content ID</strong></1>, sadržaj dostavljen putem ovog izdanja potpuno je prihvatljiv za YouTube Content ID.",
                "youtube_content_id_eligible": "Potvrđujem da je moj sadržaj prihvatljiv za <strong>YouTube Content ID</strong>",
                "youtube_content_id_not_eligible": "Moj sadržaj nije prihvatljiv za <strong>YouTube Content ID</strong>",
                "immersive_audio": "Ovo izdanje ima imerzivni zvuk"
            },
            "placeholder": {
                "version": "Ostavite prazno ako niste sigurni ili ako je ovo redovno izdanje",
                "select_date": "Odaberite datum...",
                "copyright": "Obično naziv vaše etikete",
                "copyright_publisher": "Obično naziv vaše etikete",
                "copyright_year": "GGGG",
                "copyright_year_publisher": "GGGG",
                "catalog_number": "Unesite svoj kataloški broj. Obično etikete unose skraćenicu naziva etikete i broj. Npr. {{prefix}}001, {{prefix}}002...",
                "label": "Odaberite etiketu...",
                "subuser": "Odaberite pod-korisnika...",
                "artist": "Odaberite umjetnika...",
                "genre": "Odaberite žanr...",
                "subgenre": "Odaberite podžanr...",
                "ean": "Ostavite prazno ako niste sigurni!",
                "release_description": "Nekoliko riječi o vašem izdanju. Molimo bez linkova i e-mail adresa. Maksimalno 600 znakova"
            },
            "help_text": {
                "name": "Molimo ne koristite dodatke nazivu izdanja kao što su LP i EP.",
                "version": "Neka izdanja se izdaju u više verzija, ako je tako, unesite naziv verzije. Ako je vaše izdanje originalno/standardno izdanje, zanemarite ovo polje.",
                "subuser": "Napomena: Koristite ovaj padajući izbornik samo ako želite dodati izdanje za bilo kojeg od svojih pod-korisnika, inače ostavite neizabrano.",
                "catalog_number": "Unesite svoj kataloški broj. Obično etikete unose skraćenicu naziva etikete i broj. Npr. {{prefix}}001, {{prefix}}002...",
                "artwork": "Prenesite JPG formate, rezolucija samo 3000x3000 px, @ 72 dpi",
                "original_release_date": "Izvorni datum izdanja za sve trgovine širom svijeta.",
                "official_release_date": "Službeni datum izdanja za sve trgovine širom svijeta.",
                "release_language": "Na kojem je jeziku napisan naziv izdanja? Molimo dvaput provjerite ako niste sigurni. Ako je ovaj unos pogrešan, neke trgovine poput iTunesa i Apple Musica odbit će izdanje.",
                "ean": "Univerzalni kod proizvoda ili europski broj artikla za izdanje. Valjani kodovi su 13 znamenki. Ako nemate svoj, generirat ćemo ga za vas."
            },
            "option": {
                "yes": "Da",
                "no": "Ne",
                "no_exclusive": "Bez ekskluzive",
                "beatport_2weeks": "Beatport 2 tjedna",
                "beatport_4weeks": "Beatport 4 tjedna",
                "preorder_1week": "Prednarudžba 1 tjedan",
                "preorder_2weeks": "Prednarudžba 2 tjedna",
                "traxsource_2weeks": "Traxsource 2 tjedna",
                "select": "Odaberite...",
                "worldwide": "Širom svijeta",
                "only_selected": "Samo odabrane zemlje",
                "all_except_selected": "Sve osim odabranih zemalja"
            },
            "message": {
                "track_name_required": "Molimo unesite naziv pjesme",
                "mix_name_required": "Molimo unesite naziv miksa",
                "mix_name_invalid": "Naziv miksa može se sastojati samo od slova, brojeva, razmaka i podvlake",
                "artist_required": "Molimo odaberite umjetnika",
                "artist_type_required": "Molimo odaberite vrstu umjetnika",
                "catalog_duplicate": "Kataloški broj '{{number}}' je već korišten. Molimo unesite drugi.",
                "artist_added": "Novi umjetnik je dodan!",
                "track_limit": "Vaša trenutna kvota za pjesme je {{trackLimit}} pjesama. Da biste prenijeli više pjesama, nadogradite svoj račun ili kontaktirajte naš tim za podršku.",
                "select_day": "Molimo odaberite dan.",
                "form_error": "Obrazac se ne može poslati! Molimo ispunite sva polja i provjerite pogreške!",
                "ean_invalid": "Vrijednost nije valjan EAN. Ako unosite novo izdanje, ostavite ovo polje prazno i mi ćemo generirati EAN za vas. Ako prenosite povratni katalog i EAN nije valjan, molimo kontaktirajte nas.",
                "ean_length": "EAN broj mora imati 13 znakova",
                "artwork_invalid": "Ova datoteka nije valjana, molimo provjerite da slika ima .jpg ekstenziju, RGB boje, dimenzije 3000 X 3000 i do 4MB.",
                "track_invalid": "Ova datoteka nije valjana, molimo provjerite da je datoteka pravilno kodirana u 16 bit, 44.1 Khz."
            },
            "button": {
                "submit": "Pošalji obrazac"
            },
            "modal": {
                "assisted_days": {
                    "header": "Jeste li sigurni da želite ignorirati najbolje prakse za datum izdanja?",
                    "body": "Napomena: odabirom ove opcije, vaš datum izdanja možda neće biti prihvaćen od strane trgovina ili unesen i objavljen na odabrani datum. Osim toga, značajno smanjujete marketinške mogućnosti.",
                    "button": {
                        "cancel": "Otkaži",
                        "confirm": "Potvrdi"
                    }
                },
                "release_updated": {
                    "header": "Izdanje ažurirano!",
                    "body": "Vaše izdanje je uspješno ažurirano!",
                    "button": {
                        "close": "Zatvori"
                    }
                }
            }
        }
    },
    "artists_row": {
        "artistType": {
            "main": "Glavni umjetnik",
            "featuring": "Gostujući umjetnik",
            "remixer": "Remikser"
        },
        "placeholder": {
            "selectArtist": "Odaberite umjetnika..."
        },
        "button": {
            "remove": "Ukloni",
            "addAnother": "Dodaj još jednog",
            "createNew": "Stvori novog?"
        },
        "modal": {
            "header": "Jeste li sigurni da želite dodijeliti ovog umjetnika kao gostujućeg umjetnika?",
            "body": "Molimo ne miješajte gostujućeg umjetnika s remikserom. Gostujući umjetnik treba biti dodan samo ako ste sigurni da ovaj umjetnik nije glavni umjetnik ili remikser.",
            "cancel": "Otkaži",
            "confirm": "Potvrdi"
        },
        "label": {
            "order": "Redoslijed",
            "artistName": "Ime umjetnika",
            "artistType": "Vrsta umjetnika",
            "artists": "Umjetnici",
            "required": "Obavezno"
        },
        "help_text": {
            "artists": "Ako je izdanje napisano od strane više od <strong>4 glavna umjetnika</strong> molimo koristite <strong>Razni umjetnici</strong>. Umjetnici pjesama, remikseri i suradnici trebaju biti dodani u koraku uređivanja pjesama."
        }
    },
    "tracks_row": {
        "label": {
            "tracks": "Pjesme",
            "order": "Redoslijed",
            "trackName": "Naziv pjesme",
            "mixName": "Naziv miksa",
            "file": "Datoteka",
            "albumOnly": "Samo album",
            "required": "Obavezno",
            "stereo": "Stereo",
            "dolbyAtmos": "Dolby Atmos",
            "addAnother": "Dodaj još jednu",
            "remove": "Ukloni?",
            "onlyAlbum": "Samo album",
            "mixTypes": {
                "originalMix": "Originalni miks",
                "remixOrMix": "Ovo je remiks ili miks"
            }
        },
        "button": {
            "remove": "Ukloni",
            "addAnother": "Dodaj još jednu"
        },
        "validation": {
            "trackName": "Molimo unesite naziv pjesme",
            "mixName": "Molimo unesite naziv miksa",
            "mixNameRegex": "Naziv miksa može se sastojati samo od slova, brojeva, razmaka i podvlake",
            "trackFile": "Molimo odaberite datoteku pjesme",
            "trackFileDolby": "Molimo odaberite Dolby Atmos datoteku pjesme",
            "trackFileDuration": "Trajanje stereo i Dolby datoteka pjesama mora se podudarati",
            "swapTrackAudioTokenRequiredTooltip": "Vaš trenutni saldo tokena nije dovoljan. Potreban je najmanje 1 token za zamjenu audio zapisa pjesme."
        }
    },
    "transfer_artists_row": {
        "label": {
            "artists": "Umjetnici",
            "order": "Redoslijed",
            "artistName": "Ime umjetnika",
            "artistType": "Vrsta umjetnika",
            "required": "Obavezno"
        },
        "placeholder": {
            "selectArtist": "Odaberite umjetnika..."
        },
        "help_text": {
            "artists": "Ako je izdanje napisano od strane više od <strong>4 glavna umjetnika</strong> molimo koristite <strong>Razni umjetnici</strong>. Umjetnici pjesama, remikseri i suradnici trebaju biti dodani u koraku uređivanja pjesama."
        },
        "option": {
            "artistType": {
                "main": "Glavni umjetnik",
                "featuring": "Gostujući umjetnik",
                "remixer": "Remikser"
            }
        },
        "button": {
            "remove": "Ukloni",
            "addAnother": "Dodaj još jednog",
            "createNew": "Stvori novog?"
        },
        "message": {
            "errorArtistRequired": "Molimo odaberite umjetnika",
            "errorArtistTypeRequired": "Molimo odaberite vrstu umjetnika"
        },
        "modal": {
            "header": "Jeste li sigurni da želite dodijeliti ovog umjetnika kao gostujućeg umjetnika?",
            "body": "Molimo ne miješajte gostujućeg umjetnika s remikserom. Gostujući umjetnik treba biti dodan samo ako ste sigurni da ovaj umjetnik nije glavni umjetnik ili remikser.",
            "button": {
                "cancel": "Otkaži",
                "confirm": "Potvrdi"
            }
        }
    },
    "store_picker": {
        "label": {
            "stores": "Trgovine"
        },
        "placeholder": {
            "search": "Pretraži trgovinu..."
        },
        "section": {
            "mandatory": "Obavezno",
            "optional": "Opcionalno",
            "optional_locked": "Opcionalno Dodatne Trgovine",
            "summary": {
                "read_only": "{{title}} (ukupno {{count}})",
                "editable": "{{title}} (ukupno {{total}}, odabrano {{selected}})"
            }
        },
        "message": {
            "no_stores": "Nema pronađenih trgovina.",
            "availability": "Beatport je dostupan samo za Dance izdanja s Beatport-odobrenim labelima. Traxsource je dostupan samo za Dance izdanja s Traxsource-odobrenim labelima.",
            "youtube_declaration": "Molimo prvo potpišite YouTube Content ID izjavu.",
            "youtube_ineligible": "Ova trgovina nije dostupna jer ste naveli da nemate vlasnička prava. Ako je to lažno prijavljeno, mogli biste odgovarati u pravnom sporu.",
            "youtube_content_id": "Ova trgovina nije primjenjiva za izdanja koja ispunjavaju uvjete za YouTube Content ID jer se isporučuje i na YouTube Content ID i na YouTube Premium.",
            "beatport": "Beatport se može odabrati samo kada je žanr Dance i label je odobren za Beatport.",
            "traxsource": "Traxsource se može odabrati samo kada je žanr Dance i label je odobren za Traxsource.",
            "juno": "JunoDownload se može odabrati samo kada je žanr Dance.",
            "contact_support": "Molimo kontaktirajte naš tim podrške kako biste otključali te trgovine.",
            "optional_additional_none_selected": "Niste odabrali nijednu opcionalnu dodatnu trgovinu. One mogu proširiti vaš doseg. Jeste li sigurni da ih želite preskočiti?",
            "optional_paid_insufficient_tokens": "Nedovoljan saldo tokena. Za odabir opcionalnih dodatnih trgovina potreban je najmanje 1 token.",
            "optional_paid_insufficient_tokens_with_link": "Vaš trenutni saldo tokena nije dovoljan. Za odabir opcionalnih dodatnih trgovina potreban je najmanje 1 token. <2>Naručite tokene</2> za nastavak."
        }
    },
    "transfer_tracks_row": {
        "label": {
            "tracks": "Pjesme",
            "order": "Redoslijed",
            "trackName": "Naziv pjesme",
            "mixName": "Naziv miksa",
            "file": "Datoteka",
            "albumOnly": "Samo album",
            "required": "Obavezno",
            "stereo": "Stereo",
            "dolbyAtmos": "Dolby Atmos",
            "addAnother": "Dodaj još jednu",
            "remove": "Ukloni?",
            "onlyAlbum": "Samo album",
            "mixTypes": {
                "originalMix": "Originalni miks",
                "remixOrMix": "Ovo je remiks ili miks"
            }
        },
        "button": {
            "remove": "Ukloni",
            "addAnother": "Dodaj još jednu"
        },
        "validation": {
            "trackName": "Molimo unesite naziv pjesme",
            "mixName": "Molimo unesite naziv miksa",
            "mixNameRegex": "Naziv miksa može se sastojati samo od slova, brojeva, razmaka i podvlake",
            "trackFile": "Molimo odaberite datoteku pjesme",
            "trackFileDolby": "Molimo odaberite Dolby Atmos datoteku pjesme",
            "trackFileDuration": "Trajanje stereo i Dolby datoteka pjesama mora se podudarati"
        }
    }
};

export default releasesHR;